/**
 * @file guards.ts
 * @description 通用类型守卫工具。这里只放与业务无关的运行时校验，避免各层重复写弱类型判断。
 */

/**
 * 判断一个值是否为有限数字。
 */
export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value)
}

/**
 * 判断一个值是否为非空对象。
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
